import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Card } from 'ant-design-vue';
import { CSSProperties } from 'vue';

interface Props {
  title?: string | undefined;
  loading?: boolean;
  bodyStyle?: CSSProperties;
  headStyle?: CSSProperties;
  size?: 'small' | 'default';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RexCardV3',
  props: {
    title: { default: undefined },
    loading: { type: Boolean, default: false },
    bodyStyle: { default: () => ({}) },
    headStyle: { default: () => ({}) },
    size: { default: 'small' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), {
    title: props.title,
    size: props.size,
    loading: props.loading,
    bodyStyle: _ctx.bodyStyle,
    headStyle: _ctx.headStyle,
    bordered: false
  }, {
    title: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["title", "size", "loading", "bodyStyle", "headStyle"]))
}
}

})